/**
 * @flow
 * @relayHash 0b951246834b8ad1b6bf673c0c3900df
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FishLeaderboardResult_getFishLeaderboard$ref = any;
export type FishLeaderboardResultRefetchQueryVariables = {|
  event_token: string
|};
export type FishLeaderboardResultRefetchQueryResponse = {|
  +$fragmentRefs: FishLeaderboardResult_getFishLeaderboard$ref
|};
export type FishLeaderboardResultRefetchQuery = {|
  variables: FishLeaderboardResultRefetchQueryVariables,
  response: FishLeaderboardResultRefetchQueryResponse,
|};
*/


/*
query FishLeaderboardResultRefetchQuery(
  $event_token: String!
) {
  ...FishLeaderboardResult_getFishLeaderboard_HAbmK
}

fragment FishLeaderboardResult_getFishLeaderboard_HAbmK on Query {
  getFishLeaderboard(event_token: $event_token) {
    code
    message
    data {
      points_per_team {
        group_id
        points
        position
      }
      all_answers {
        group_id
        points
        guest {
          guest_name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_token",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "event_token",
    "variableName": "event_token"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "group_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FishLeaderboardResultRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "FishLeaderboardResult_getFishLeaderboard",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FishLeaderboardResultRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getFishLeaderboard",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "fishLeaderboardType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "fishLeaderboardDataType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "points_per_team",
                "storageKey": null,
                "args": null,
                "concreteType": "pointsPerTeamType",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "position",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "all_answers",
                "storageKey": null,
                "args": null,
                "concreteType": "allAnswersType",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "guest",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "fishGuestType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "guest_name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FishLeaderboardResultRefetchQuery",
    "id": null,
    "text": "query FishLeaderboardResultRefetchQuery(\n  $event_token: String!\n) {\n  ...FishLeaderboardResult_getFishLeaderboard_HAbmK\n}\n\nfragment FishLeaderboardResult_getFishLeaderboard_HAbmK on Query {\n  getFishLeaderboard(event_token: $event_token) {\n    code\n    message\n    data {\n      points_per_team {\n        group_id\n        points\n        position\n      }\n      all_answers {\n        group_id\n        points\n        guest {\n          guest_name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b89a63ae2ff5b4d4194a43e4b02b1d06';
module.exports = node;
